import { render, staticRenderFns } from "./ReferralFinancialForm.vue?vue&type=template&id=4bd6259f&"
import script from "./ReferralFinancialForm.vue?vue&type=script&lang=ts&"
export * from "./ReferralFinancialForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports